const faqs = [
  {
    q: '樱花漫画网的漫画都是免费的吗？',
    a: '是的，樱花漫画网所有漫画全集均为免费阅读，包括韩漫、日漫、国漫等全部类型。我们提供完整版下拉式阅读体验，无需付费即可畅享全本漫画内容，一次看个够。',
  },
  {
    q: '什么是下拉式阅读模式？',
    a: '下拉式阅读是樱花漫画网的核心阅读方式，您无需点击翻页按钮，只需像浏览网页一样向下滑动即可连续阅读完整漫画章节。相比传统翻页模式更加流畅自然，特别适合手机端阅读体验。',
  },
  {
    q: '网站上的漫画多久更新一次？',
    a: '樱花漫画网坚持每日更新，热门连载漫画保持与官方同步的更新频率。每当有新的章节发布，我们会第一时间上架，确保读者能够及时追更喜欢的全本漫画作品。',
  },
  {
    q: '支持哪些类型的漫画作品？',
    a: '樱花漫画网涵盖热血、恋爱、悬疑、奇幻、搞笑、都市、校园、古风、科幻、惊悚等全部类型。无论您喜欢韩漫、日漫还是国漫，都能在这里找到好看的完整版全本漫画资源。',
  },
  {
    q: '如何在手机上获得更好的阅读体验？',
    a: '樱花漫画网已全面适配移动端，在手机浏览器中打开即可享受流畅的下拉式阅读。您也可以将网站添加到手机桌面，像使用APP一样快速访问。此外我们还提供专属APP下载，带来更沉浸的全集漫画阅读体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于樱花漫画网，你可能想知道的都在这里
        </p>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full text-sm font-bold mt-0.5">
                  {idx + 1}
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}